/* 银行及银行卡相关接口 */

import axios from 'axios';
import qs from 'qs';

export default {
  getBankcardListData (params) { // 获取银行卡列表数据
    return axios.get('/mobile/crmCustomerBankAccountInfoController/getBankListMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyId: params.frontApplyId,
        type: params.type
      }
    });
  },

  saveBankcardInfo (params) { // 保存银行卡数据
    return axios.get('/mobile/crmCustomerBankAccountInfoController/saveBankInfoJL.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        customerId: params.customerId,
        bankType: params.bankType,
        bankUserName: params.bankUserName,
        bankAccountName: params.bankAccountName,
        bankName: params.bankName,
        bankBranchName: params.bankBranchName,
        bankAccountId: params.bankAccountId,
        bankCounty: params.bankCounty,
        bankProvince: params.bankProvince,
        bankCity: params.bankCity,
        bankUseType: params.bankUseType,
        bankSwift: params.bankSwift
      }
    });
  },

  deleteBankcardInfo (params) { // 删除银行卡
    return axios.post('/mobile/crmCustomerBankAccountInfoController/deleteBankAccount.ht', qs.stringify({
      bankAccountId: params.bankAccountId
    }), {
      headers: {
        tokenId: params.token
      }
    });
  },

  getBankcardSelectData (params) { // 获取银行可选列表，用于开户银行模糊查询
    return axios.get('mobile/crmCustomerBankAccountInfoController/searchBankList.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        bankName: params.bankName,
        limit: params.limit
      }
    });
  },

  getProvinceData () { // 查询可选省份
    return axios.get('/loanform/item/region/getProvince.ht');
  },

  getCityAndDistrictData (params) { // 查询可选城市和区县
    return axios.get('/loanform/item/region/getCityOrCounty.ht', {
      params: {
        code: params.code
      }
    });
  }

};



// WEBPACK FOOTER //
// ./src/api/personalCenter/bankCardList.js